module.exports = __webpack_public_path__ + "static/media/logo-w.0a7c7079.png";